import React from "react";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { useGetBillingPortal } from "@src/api/stripe/get-billing-portal";
import { IgAlertSimpleInverted } from "@src/components/Utils/IgAlertSimpleInverted";

interface NoBillingAlertProps {
  stripeCustomerId?: string;
  stripeSubscriptionId?: string;
}
export const NoBillingAlert = ({
  stripeCustomerId,
  stripeSubscriptionId,
}: NoBillingAlertProps) => {
  const getBillingPortal = useGetBillingPortal(true);

  return (
    <Grid item>
      <IgAlertSimpleInverted
        colorBackground={true}
        alertKey={"no-billing-method"}
        severity={"error"}
        message={
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Grid item>
              <IgTypography variant={"body2"}>
                This customer does not have a billing method on file.
              </IgTypography>
            </Grid>
            <Grid item>
              <IgButton
                variant={"contained"}
                color={"error"}
                loading={getBillingPortal.isPending}
                onClick={() => {
                  getBillingPortal.mutate({
                    pathParams: undefined,
                    queryParams: undefined,
                    body: {
                      stripeCustomerId,
                      stripeSubscriptionId,
                    },
                  });
                }}
              >
                Create Payment Link
              </IgButton>
            </Grid>
          </Grid>
        }
      />
    </Grid>
  );
};
